module.exports = __webpack_public_path__ + "img/Manhole.63773f0b.svg";